<template>
<div style="display:flex; align-items:center; position: relative;">
  <img src="@images/1-star.png" alt="1 star" aria-hidden="true" role="none"/>
  <img 
    src="@images/5-stars.png" 
    :style="`position: absolute; left:0; clip-path: polygon(0% 0%, ${fillPerc}% 0%, ${fillPerc}% 100%, 0% 100%);`" 
    :alt="`${rating} star${rating > 1 ? 's' : ''} rating`" 
    role="presentation" 
    :aria-label="`${rating} star${rating > 1 ? 's' : ''} rating`"
  />
</div>
</template>

<script setup lang="ts">
  import { computed } from "vue";
  import { useClamp } from '@vueuse/math'
  let props = defineProps({
    rating: {
      type: Number,
      default: 0
    }
  })

  const fillPerc = computed(()=>{
    let stars = useClamp(+props.rating, 0, 5);
    return Math.trunc(+((stars.value/5) * 100).toFixed(0));
  })

</script>
